import {$Diff} from 'utility-types'

import * as React from 'react'

import {equals} from 'ramda'
import URLParamsMapper from './URLParamsMapper'

type WithURLParamsMapperStateType = {
  urlParams: Record<string, unknown>
}

function withURLParamsMapper<Config extends Record<string, unknown>>(
  Component: React.AbstractComponent<Config>
) {
  class WithURLParamsMapper extends React.PureComponent<
    $Diff<Config, typeof URLParamsMapper>,
    WithURLParamsMapperStateType
  > {
    state = {
      urlParams: URLParamsMapper()
    }

    static getDerivedStateFromProps(
      props: Record<string, unknown>,
      state: WithURLParamsMapperStateType
    ) {
      if (equals(state.urlParams, URLParamsMapper())) return null

      return {
        urlParams: URLParamsMapper()
      }
    }

    render() {
      return <Component {...this.props} {...this.state.urlParams} />
    }
  }

  WithURLParamsMapper.displayName = `
  withURLParamsMapper(${Component.name || ''})
`
  return WithURLParamsMapper
}

export default withURLParamsMapper
